import { NumberService } from 'Services';
import { TFunction } from 'i18next';
import { ADDTIONAL_CONCLUSION_VALUES_KEY } from './constants';

export const getDeployCount = ({ acquirerSummary, totalUpdates }: DeploymentSummary) => {
    return Number(acquirerSummary.configUpdated) + totalUpdates;
};

export const getDeployCountString = (data: DeploymentSummary) => {
    return NumberService.getLocaleNumber(getDeployCount(data));
};

export const hasDeployedRevision = (rulesTemplate: RulesData) => {
    return rulesTemplate.isDeployed;
};

export const getFullStringCondition = (t: TFunction, condition: string) => {
    return t(`conditions.${condition}`);
};

export const getCommaSeparatedNumericValue = (value: number) => {
    return NumberService.getLocaleNumber(value, {
        maximumFractionDigits: 2
    });
};

export const getCommaSeparatedCurrencyValue = (value: number) => {
    return NumberService.getLocaleCurrency(value, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

// As Execution Order view does not apply to Templated Rules,

// Execution Order views across the application should not show Templated Rules
export const getRulesFormatForView = (rules: Rule[], isGlobalRuleSelectOption: boolean) => {
    return !isGlobalRuleSelectOption ? (rules || []).filter((rule: Rule) => rule.nonTemplated) : rules;
};

export const getAdditionalFlags = (flagArray: AdditionalConclusionValues[], actionValueArray: string[]) => {
    return flagArray.reduce(
        (total: string[], current: AdditionalConclusionValues) =>
            actionValueArray.includes(current.name) ? [...total, current.description] : total,
        []
    );
};

export const getAdditionalFlagValuesFromStorage = () => {
    try {
        const additionalConclusions = localStorage.getItem(ADDTIONAL_CONCLUSION_VALUES_KEY);
        const conclusionFlagListData = additionalConclusions ? JSON.parse(additionalConclusions) : [];
        return conclusionFlagListData;
    } catch (_error) {
        return [];
    }
};
